<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
  >
    <v-card class="rounded-lg">
      <!-- Close button -->
      <v-btn
        icon
        absolute
        right
        top
        @click="cancel"
        class="mt-2 mr-2"
        style="float: right;"
      >
        <v-icon color="grey">mdi-close</v-icon>
      </v-btn>
      
      <v-card-text class="text-center pa-8 pb-6">
        <!-- Delete Icon SVG -->
        <div class="mb-5 mt-5 flex justify-center">
          <img 
            src="@/assets/trash.svg" 
            alt="Delete"
            width="75"
            height="76"
          />
        </div>
        
        <!-- Title -->
        <h2 class="text-h5 font-weight-bold mb-4" style="color: #19233A;">
          Delete Scan
        </h2>
        
        <!-- Message -->
        <p class="text-body-1 mb-0" style="color: #6b7280;">
          Are you sure you want to delete these scan(s)?
        </p>
      </v-card-text>
      
      <v-card-actions class="justify-center pb-8 px-8">
        <v-btn
          outlined
          class="mr-4 text-uppercase"
          style="min-width: 120px; height: 44px; border: 1px solid 1px solid #2477f6; color: #6b7280; font-weight: 500; font-size: 14px;"
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          depressed
          class="text-uppercase"
          style="min-width: 120px; height: 44px; background-color: #2477f6; color: white; font-weight: 500; font-size: 14px;"
          @click="confirm"
          :loading="loading"
        >
          Yes, Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
/* Custom styles for the delete dialog */
</style>